/**
 * OneFront SDK
 * ============
 *
 * This package provides most of the Services that you may need
 * in a OnePlatform Application.
 *
 * You write simple React Components and interact with the SDK
 * using modern hooks API.
 *
 * The SDK guides you into dividing you App into isolated Features
 * that you will glue together using ForrestJS APIs.
 */
import onefront from "@onefront/react-sdk";

/**
 * Import the App's Features
 * =========================
 *
 * A Feature is an isolated portion of business logic that
 * interacts with the App's Services
 */
import { dashboard } from "./features/dashboard";
import { examples } from "./features/examples";
import { userDetails } from "./features/user-details";
import { notifications } from "./features/UI/components/notifications";
import { preferiti } from "./features/UI/components/preferiti";
import { recenti } from "./features/UI/components/recenti";
import {leadManagement} from "./features/leadManagement"

/**
 * Configure and Run the App
 * =========================
 *
 * The boot process returns a Promise that you can handle
 * to figure out whether all was good or not.
 */
onefront
  .run({
    trace: "compact",
    settings: {
      one: {
        // Forces a JWT refresh on every FPR
        auth: {
          token: {
            verify: true,
            refresh: true,
          },
        },
        layout: {
          title: "ReactSDK Boilerplate",
          appSwitch: false
        },
        login: {
          target: {
            params: ["mode=redirect", "appId=demo"],
          },
        },
      },
      examples: {
        chuckNorris: {
          url: "https://api.chucknorris.io/jokes/random",
        },
      },
    },
    features: [
      dashboard,
      examples,
      leadManagement,
      recenti,
      preferiti,
      notifications,
      userDetails,
    ],
  })
  .catch(console.error);
